import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";

import {
  Community,
  CommunityService,
  CommunityListConfig,
  Discussion,
  DiscussionService,
} from "../../../shared";
import { AngularEditorConfig } from "@kolkov/angular-editor";

@Component({
  selector: "discussion-editor-page",
  templateUrl: "./discussion-editor.component.html",
  styleUrls: [
    "./discussion-editor.component.scss",
    "../../../../assets/icon/icofont/css/icofont.scss",
    "../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DiscussionEditorComponent implements OnInit {
  public discussion: Discussion = new Discussion();
  public discussionForm: FormGroup;
  public discussionImageField = new FormControl();
  public errors: Object = {};
  public isSubmitting: boolean = false;
  public config: CommunityListConfig = new CommunityListConfig();
  public userCommunities: string[];
  public editMode = false;
  public communityPlaceholder: string = "Select community";

  // editor config
  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "25rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    uploadUrl: "v1/images", // if needed
    customClasses: [
      // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  constructor(
    private discussionService: DiscussionService,
    private communityService: CommunityService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.prepareDiscussionForm();
    this.fetchDiscussion();
    this.fetchUserCommunities();
    this.trackDiscussionFormChanges();
  }

  public prepareDiscussionForm() {
    this.discussionForm = this.fb.group({
      title: ["", Validators.required],
      description: ["", Validators.required],
      community: new FormControl("", {
        validators: [Validators.required],
      }),
      body: ["", Validators.required],
      image: "",
      tagList: new FormControl([]),
    });
  }

  public trackDiscussionFormChanges() {
    this.discussionForm.valueChanges.subscribe((value) => {
      this.updateDiscussion(value);
    });
  }

  public updateDiscussion(values: Object) {
    if (!this.editMode) {
      if (values["community"].length > 0) {
        values["community"] = values["community"][0];
      }
    }

    (<any>Object).assign(this.discussion, values);
  }

  public fetchDiscussion() {
    this.route.data.subscribe((data: { discussion: Discussion }) => {
      if (data.discussion) {
        this.editMode = true;
        this.discussion = data.discussion;
        this.populateDiscussionForm(data.discussion);
      }
    });
  }

  public populateDiscussionForm(discussion: Discussion) {
    this.discussionForm.patchValue(discussion);
    this.communityPlaceholder = discussion.community.name;
  }

  public fetchUserCommunities() {
    this.config.type = "AllCommunitiesMembershipFeed";
    this.communityService
      .findMany(this.config)
      .subscribe((data: { communities: Array<Community> }) => {
        this.userCommunities = data.communities.map((c) => c.name);
      });
  }

  public saveImage(url: string) {
    this.discussionImageField.setValue(url);
  }

  public saveDiscussion() {
    this.errors = {};
    this.isSubmitting = true;
    this.discussion.image = this.discussionImageField.value;

    this.discussionService.saveOne(this.discussion).subscribe(
      (discussion: Discussion) => {
        this.fireSuccessAlert();
        this.router.navigateByUrl("/discussion/" + discussion.slug);
      },
      (err) => {
        this.errors = err;
        this.isSubmitting = false;
        this.fireErrorAlert();
      }
    );
  }

  public openDiscussionPublishConfirmation() {
    Swal.fire({
      title: "Sure you want to publish this nDaba?",
      text: "You can always edit the nDaba after posting",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, publish!",
    }).then((result) => {
      if (result.value) {
        this.saveDiscussion();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire("Published", "Your nDaba has been published.", "success");
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your submission.", "warning");
    window.scrollTo(0, 0);

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }
}
